import { Helmet } from "react-helmet-async";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function Consent() {
  return (
    <main className="mx-auto w-full max-w-3xl px-4 py-8 space-y-4">
      <Helmet>
        <title>Consent & Preferences | FANZ</title>
        <meta name="description" content="Manage GDPR/CCPA consent and preferences." />
        <link rel="canonical" href={typeof window !== 'undefined' ? window.location.href : 'https://example.com/consent'} />
      </Helmet>
      <h1 className="text-2xl font-semibold">Consent & Preferences</h1>
      <Card>
        <CardHeader><CardTitle>Advertising</CardTitle></CardHeader>
        <CardContent className="flex items-center gap-3">
          <Button variant="secondary">Reject non-essential</Button>
          <Button>Allow personalized</Button>
        </CardContent>
      </Card>
    </main>
  );
}
